import { render, staticRenderFns } from "./dialog_release.vue?vue&type=template&id=37a170ba&scoped=true&"
import script from "./dialog_release.vue?vue&type=script&lang=js&"
export * from "./dialog_release.vue?vue&type=script&lang=js&"
import style0 from "./dialog_release.vue?vue&type=style&index=0&id=37a170ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a170ba",
  null
  
)

export default component.exports